import { isNil } from 'lodash';
import { AnchoredSheet } from '@shared/components/AnchoredSheet';
import { MBButton } from '@shared/components/MBButton';
import { View } from '@shared/components/View';
import { TextInput } from '@shared/components/textInput';
import { MBTextOverlineBold } from '@shared/components/typography';

import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';

interface RenameSheetProps {
  anchorName: string;
  workflowName: string;
  setWorkflowName: (workflowName: string) => void;
  isSubform: boolean;
  onClose?: () => void;
  onPress?: () => void;
  buttonLabel?: string;
}

export function RenameSheet({
  anchorName,
  workflowName,
  setWorkflowName,
  isSubform,
  onClose,
  onPress,
  buttonLabel = i18n('common.create'),
}: RenameSheetProps) {
  const isDesktop = useIsDesktop();

  return (
    <AnchoredSheet anchorName={anchorName} onClose={!isNil(onClose) ? onClose : () => {}}>
      <View padding={2}>
        <MBTextOverlineBold>
          {isSubform && i18n('workflowTemplate.subformName')}
          {!isSubform && i18n('workflowTemplate.name')}
        </MBTextOverlineBold>
        <View paddingTop={1} paddingBottom={2}>
          <TextInput
            defaultValue={workflowName}
            onChangeText={setWorkflowName}
            autoFocus
            maxLength={64}
          />
        </View>
        {!isNil(onPress) && (
          <MBButton title={buttonLabel} onPress={onPress} size={isDesktop ? 'small' : 'normal'} />
        )}
      </View>
    </AnchoredSheet>
  );
}
